import { Component, Input } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { clearField, DateTableFilter, getError, SmartFormContainer } from '@shared';
import { BreakpointService } from '@services';

@Component({
  selector: 'app-date-filter',
  templateUrl: './date-filter.component.html',
  styleUrls: ['./date-filter.component.scss'],
})
export class DateFilterComponent extends SmartFormContainer {
  readonly getError = getError;
  readonly clearField = clearField;
  readonly isMobile$ = this.breakpointService.isMobile$;
  @Input() config: DateTableFilter;

  get control(): FormControl {
    return this.form.get(this.controlName) as FormControl;
  }

  constructor(
    protected fb: FormBuilder,
    private breakpointService: BreakpointService,
  ) {
    super(fb);
  }

  stopPropagation(event: MouseEvent): void {
    event.stopPropagation();
  }
}
